// extracted by mini-css-extract-plugin
export default {"pageLayout":"Rr4knggkNcEfevyJn01c","pageLayoutContent":"fK3UJz70nyURKNSTTK8w","pageLayoutSidebar":"iJUC6TiR5k0aqBvpxnpI","pageLayoutTitle":"U9UoO0m7k2QNykiOaUkB"};